import React, {useEffect, useState} from 'react';
import {Alert, Box, Button, CircularProgress, Container, Paper, Stack, Typography} from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import ApiService from '../network/API';
import ScheduleDays from '../components/ScheduleDays';

const BOT_URL = 'https://t.me/raspisaniePGKbot';

// Расписание студента: только сегодняшний день его группы; на остальные дни — переход в Telegram-бот колледжа.
const SchedulePage = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = 'Расписание';
        ApiService.getMySchedule()
            .then(setData)
            .catch((e) => setError((typeof e === 'string' ? e : e?.reason || e?.message) || 'Не удалось загрузить расписание'))
            .finally(() => setLoading(false));
    }, []);

    const today = data?.days?.[0];

    return (
        <Container maxWidth="md" sx={{py: 4}}>
            <Typography variant="h4" fontWeight={700}>Расписание на сегодня</Typography>
            {data && (
                <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                    Группа {data.teacher}
                    {data.updatedAt && ` · обновлено ${new Date(data.updatedAt).toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'})}`}
                </Typography>
            )}

            <Paper variant="outlined" sx={{p: 2, borderRadius: 2, mb: 3}}>
                <Stack direction={{xs: 'column', sm: 'row'}} spacing={2} alignItems={{sm: 'center'}} justifyContent="space-between">
                    <Box>
                        <Typography fontWeight={700}>Расписание на другие дни</Typography>
                        <Typography variant="body2" color="text.secondary">Завтра, неделя и изменения — в Telegram-боте колледжа @raspisaniePGKbot.</Typography>
                    </Box>
                    <Button variant="contained" startIcon={<TelegramIcon/>} component="a" href={BOT_URL} target="_blank" rel="noopener noreferrer">
                        Открыть в Telegram
                    </Button>
                </Stack>
            </Paper>

            {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
            {loading && <Box display="flex" justifyContent="center" py={4}><CircularProgress/></Box>}
            {!loading && data && !today && <Typography color="text.secondary">Сегодня пар нет.</Typography>}
            {!loading && today && <ScheduleDays days={[today]} mode="group"/>}
        </Container>
    );
};

export default SchedulePage;
